define((require) => {
    "use strict";

    var Action              = require("editor/util/Action"),
        EditorEvents        = require("shared/services/EditorEvents"),
        Permissions         = require("shared/security/Permissions"),
        PublishableState    = require("util/PublishableState");

    /**
     * Action that will delete an experience, and all of it's potential variants.
     *
     * @class DeleteExperienceAction
     */
    return Action.extend({

        /**
         * Constructor.
         *
         * @param  {ExperienceModel} model The experience model representing the experience to delete.
         * @param  {ProjectModel} project The project model, used here for tracking purposes.
         */
        constructor: function(model, project) {
            this.__super();

            this._model = model;
            this._project = project;
        },

        executable: function() {
            return Permissions.Privileges.CREATE.can() && (!this._model.hasAtLeastState(PublishableState.PUSHED) || Permissions.Privileges.PUBLISH.can());
        },

        _performExecution: function() {
            var model = this._model,
                project = this._project;

            return model.destroy()
                .then(() => {
                    var eventProperties = {
                        projectId: project && project.get("id"),
                        experienceId: model.get("id"),
                        experienceVersion: model.get("version"),
                        experiencePushedVersion: model.get("pushedVersion"),
                        triggerOrigin: "DeleteExperienceButton"
                    };

                    EditorEvents.trigger(EditorEvents.constants.DELETE_EXPERIENCE, eventProperties);

                    return model;
                });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/actions/DeleteExperienceAction.js